// extracted by mini-css-extract-plugin
export default {"navChildren":"navigation_navChildren__2sWEe"};